/* ==========================================================================
   CheckboxRxjs > Client > Store > Actions
   ========================================================================== */

/* Types */
const DESTROY = 'CHECKBOX::DESTROY';
const DISPLAY = 'CHECKBOX::DISPLAY';
const HIDE = 'CHECKBOX::HIDE';
const RESET_STATUS = 'CHECKBOX::RESET_STATUS';
const SET_ERROR = 'CHECKBOX::SET_ERROR';
const SET_VALID = 'CHECKBOX::SET_VALID';

const TOGGLE = 'CHECKBOX::TOGGLE';

const DISABLE = 'TOGGLE::DISABLE';
const ENABLE = 'TOGGLE::ENABLE';

/* Actions */
const destroy = () => ({ type: DESTROY });
const display = () => ({ type: DISPLAY });
const hide = () => ({ type: HIDE });
const resetStatus = () => ({ type: RESET_STATUS });
const setError = () => ({ type: SET_ERROR });
const setValid = () => ({ type: SET_VALID });

const toggle = () => ({ type: TOGGLE });

const disable = () => ({ type: DISABLE });
const enable = () => ({ type: ENABLE });

/* Exports */
module.exports = {
    types: {
        DESTROY,
        DISPLAY,
        HIDE,
        RESET_STATUS,
        SET_ERROR,
        SET_VALID,
        TOGGLE,
        DISABLE,
        ENABLE
    },
    actions: {
        destroy,
        display,
        hide,
        resetStatus,
        setError,
        setValid,
        toggle,
        disable,
        enable
    }
};
